import React from 'react';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isRequired } from '../../../utils/validation';

const ResidentialStatus = ({ values }) => (
  <Content>
    {({
      globalRadioError = '',
      personDetailsResidentialStatus,
      personDetailsResidentialStatusValue1 = '',
      personDetailsResidentialStatusValue2 = '',
      personDetailsResidentialStatusValue3 = '',
      personDetailsResidentialStatusValue4 = '',
      otherLabel = ''
    }) => (
      <Field
        name="residentialStatus"
        subscription={{ touched: true, error: true }}
        validate={isRequired}
      >
        {({ meta: { touched, error }, input }) => (
          <GenericFieldWrapper
            inputId="residentialStatus"
            title={personDetailsResidentialStatus}
            validationMessage={touched && !!error ? globalRadioError : ''}
          >
            <GenericRadio.StackedSet
              groupName="residentialStatus"
              items={[
                {
                  id: 'OWNER',
                  labelText: personDetailsResidentialStatusValue1
                },
                {
                  id: 'TENANT PRIVATE',
                  labelText: personDetailsResidentialStatusValue2
                },
                {
                  id: 'TENANT PUBLIC',
                  labelText: personDetailsResidentialStatusValue3
                },
                {
                  id: 'LIVING WITH PARENTS',
                  labelText: personDetailsResidentialStatusValue4
                },
                {
                  id: otherLabel,
                  labelText: otherLabel
                }
              ]}
              selectedId={values.residentialStatus}
              {...input}
            />
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

export default ResidentialStatus;
